import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import { TrackerHelper } from '~/types/tracker-helper.interface';
import { TrackingEvent } from '~/types/tracking-event.enum';

declare global {
  interface Window {
    ga: any;
    gtag: any;
  }
}

window.ga = window.ga || undefined;
window.gtag = window.gtag || undefined;

const hasBeenInit = true;
let hasGA4BeenInit = false;
let hasGABeenInit = false;

const initializeGoogleAnalytics = (analyticsId: string): void => {
  if (!analyticsId) {
    return;
  }
  if (googleAnalyticsKeyIsV4(analyticsId)) {
    if (hasGA4BeenInit) {
      ReactGA4.reset();
    }
    ReactGA4.initialize(analyticsId);
    hasGA4BeenInit = true;
    return;
  }
  ReactGA.initialize(analyticsId);
  hasGABeenInit = true;
};

const googleAnalyticsKeyIsV4 = (analyticsId: string): boolean =>
  !!analyticsId?.startsWith('G-');

const googleAnalyticsHasBeenInitialized = (): boolean =>
  (typeof window.ga === 'function' || typeof window.gtag === 'function') &&
  hasBeenInit;

const googleAnalyticsTrackPageview = (path: string) => {
  if (googleAnalyticsHasBeenInitialized()) {
    if (hasGA4BeenInit) {
      ReactGA4.send('pageview');
    }
    if (hasGABeenInit) {
      ReactGA.pageview(path);
    }
  }
};

const googleAnalyticsTrackEvent = (name: TrackingEvent, data: any) => {
  if (googleAnalyticsHasBeenInitialized()) {
    const eventPayload = {
      // To quiet the console logs angry about missing args
      action: 'CommentSold Event',
      category: 'CommentSold Event',
      label: name,
      ...data,
    };
    if (hasGA4BeenInit) {
      ReactGA4.event(eventPayload);
    }
    if (hasGABeenInit) {
      ReactGA.event(eventPayload);
    }
  }
};

const googleAnalyticsTracker: TrackerHelper = {
  init: initializeGoogleAnalytics,
  hasBeenInitialized: googleAnalyticsHasBeenInitialized,
  trackEvent: googleAnalyticsTrackEvent,
  trackPageView: googleAnalyticsTrackPageview,
};
export default googleAnalyticsTracker;
